const monoColorArray = ["#000", "#d0d0d0", "#757575", "#3f3f3f", "#e6e6e6"]

export default monoColorArray